import { render, staticRenderFns } from "./ContainerTitle.vue?vue&type=template&id=b784abe8&scoped=true"
import script from "./ContainerTitle.vue?vue&type=script&lang=js"
export * from "./ContainerTitle.vue?vue&type=script&lang=js"
import style0 from "./ContainerTitle.vue?vue&type=style&index=0&id=b784abe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b784abe8",
  null
  
)

export default component.exports